<template>
  <div class="btn-video-container">
    <button class="youtube-button toggle-video-btn" @click="toggleVideo">
      <div class="svg-wrapper-1">
        <div class="svg-wrapper">
          <svg
            height="24"
            width="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M0 0h24v24H0z" fill="none"></path>
            <path
              d="M1.946 9.315c-.522-.174-.527-.455.01-.634l19.087-6.362c.529-.176.832.12.684.638l-5.454 19.086c-.15.529-.455.547-.679.045L12 14l6-8-8 6-8.054-2.685z"
              fill="currentColor"
            ></path>
          </svg>
        </div>
      </div>
      <span>{{ videoVisivel? 'Fechar transmissão' : 'Assistir transmissão' }}</span>
    </button>


    <div
      v-if="videoVisivel"
      class="video-container"
      ref="videoContainer"
      @mousedown="iniciarArraste"
      :style="{ top: posicao.y + 'px', left: posicao.x + 'px' }"
    >
      <div v-if="videoLink.includes('youtube')" class="box-video">
        <iframe
          width="100%"
          height="315"
          :src="`https://www.youtube.com/embed/${formataLinkVideo(videoLink)}?autoplay=1`"
          :style="{ pointerEvents: arrastando ? 'none' : 'auto' }"
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
      </div>
      <div v-else>
        <iframe
          height="350px"
          width="100%"
          :src="videoLink"
          :style="{ pointerEvents: arrastando ? 'none' : 'auto' }"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    videoLink: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      videoVisivel: false,
      arrastando: false,
      posicao: { x: 50, y: 50 },
      offset: { x: 0, y: 0 },
    };
  },
  methods: {
    toggleVideo() {
      this.videoVisivel = !this.videoVisivel;
    },
    iniciarArraste(event) {
      this.arrastando = true;
      this.offset.x = event.clientX - this.$refs.videoContainer.offsetLeft;
      this.offset.y = event.clientY - this.$refs.videoContainer.offsetTop;
      document.addEventListener("mousemove", this.mover);
      document.addEventListener("mouseup", this.pararArraste);
    },
    mover(event) {
      if (this.arrastando) {
        this.posicao.x = event.clientX - this.offset.x;
        this.posicao.y = event.clientY - this.offset.y;
      }
    },
    pararArraste() {
      this.arrastando = false;
      document.removeEventListener("mousemove", this.mover);
      document.removeEventListener("mouseup", this.pararArraste);
    },
    formataLinkVideo(link) {
      if (link.includes("youtube")) {
        return link.replace(/(.*?=)([\w-]+)&?(.*?)?$/g, "$2");
      }
      return link;
    },
  },
};
</script>

<style scoped>
.video-container {
  position: fixed;
  z-index: 1000;
  width: 410px;
  cursor: move;
  border-top: 30px solid #ccc;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

button.youtube-button {
  font-family: inherit;
  font-size: 14px;
  background: linear-gradient(to bottom, #f82410 0%, #fa5639 100%);
  color: #fff;
  font-weight: bold;
  padding: 0.3em 1em;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 5px;
  transition: all 0.3s;
}

button.youtube-button:hover {
  transform: translateY(-3px);
}

button.youtube-button:active {
  transform: scale(0.95);
}

button.youtube-button span {
  display: block;
  margin-left: 0.4em;
  transition: all 0.3s;
}

button.youtube-button svg {
  width: 18px;
  height: 18px;
  fill: white;
  transition: all 0.3s;
}

button.youtube-button .svg-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.2);
  margin-right: 0.5em;
  transition: all 0.3s;
}

button.youtube-button:hover .svg-wrapper {
  background-color: rgba(255, 255, 255, 0.5);
}

button.youtube-button:hover svg {
  transform: rotate(45deg);
}

@media (max-width: 435px) {
  .video-container {
    position: relative;
    left: initial !important;
    top: 15px !important;
    cursor: pointer !important;
    border: none !important;
    margin-bottom: 30px;
    width: 360px !important;
  }

  .btn-video-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/social/VideoTransmissao.vue